export default __webpack_public_path__ + "static/media/muted-bell-icon.8681bda5.svg";